import React, { useMemo, useState , useEffect } from "react";
import axios from "axios";
import {
  MapPin,
  Search,
  LogIn,
  User,
  ChevronDown,
  ArrowRight,
  Info,
  Lock,
  BookOpen,
  Map as MapIcon,
  ShoppingCart,
  Sparkles,
} from "lucide-react";
import ProductDetailsAndOffers from "./ProductDetailsAndOffers.jsx";
import EmptyState from "./EmptyState.jsx";
import MapAndStoresPanel from "./MapAndStoresPanel.jsx";
import CatalogSection from "./CatalogSection.jsx";
import TopSearchedProducts from "./TopSearchedProducts.jsx";
import CatalogModal from "./CatalogModal.jsx";
import Navbar from "./Navbar.jsx";
// import { MOCK_PRODUCTS, MOCK_CATALOGS } from "../../Data/data.js";
import Footer from "./Footer.jsx";
import AuthModal from "../Auth/AuthModal.jsx";
import api from "../../api.js"
import { setDocumentTitle, setMetaDescription } from "../../utils/seo";


// Mock data you can later replace with real API responses









export default function Home({selectedArea, setSelectedArea , isLoggedIn, setIsLoggedIn , setShowAuthModal , showAuthModal}) {
  // const [selectedArea, setSelectedArea] = useState("");
  const [MOCK_CATALOGS, setMockCatalogs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedCatalog, setSelectedCatalog] = useState(null);
// const [isLoggedIn, setIsLoggedIn] = useState(() => {
//   return !!localStorage.getItem("accessToken");
// });


  const [userLocation, setUserLocation] = useState(null);
  const [geoError, setGeoError] = useState("");
  // const [showAuthModal, setShowAuthModal] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [topSearchedProducts, setTopSearchedProducts] = useState([]);
  const [offersForSelectedProduct, setOffersForSelectedProduct] = useState([]);


//update title and meta description for home page
useEffect(() => {
  setDocumentTitle(
    "Gulf Deals Dubai | Find Nearby Offers & Best In-Store Prices UAE"
  );

  setMetaDescription(
    "Compare in-store prices across Dubai & UAE. Find nearby deals, discounts & offers in local shops and malls."
  );
}, []);



useEffect(() => {
  const fetchCatalogs = async () => {
    try {
      const response = await api.get(
        "/store-offer/store/top"
      );

      // Axios automatically parses JSON → response.data
      setMockCatalogs(response.data || []);

      // console.log(MOCK_CATALOGS);
      
    } catch (error) {
      console.error("Error fetching catalogs:", error);
    }
  };

  fetchCatalogs();
}, []);

  // ============================================================
  // 🔥 Fetch Product with search query
  // ============================================================

useEffect(() => {
  const handler = setTimeout(() => {
    const fetchSuggestedProducts = async () => {
      if (!searchQuery.trim() || searchQuery.trim().length < 3) {
        setFilteredProducts([]);
        return;
      }

      try {
        const res = await api.get(
          "/master-catalogue/api/catalogue/search",
          {
            params: {
              query: searchQuery,
              from: 0,
              size: 20,
            },
            headers: {
              Accept: "application/json",
            },
          }
        );

        setFilteredProducts(res.data || []);
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setFilteredProducts([]);
      }
    };

    fetchSuggestedProducts();
  }, 300); // ⏳ Debounce delay (300ms)

  // Cleanup: cancel previous timeout if searchQuery changes
  return () => clearTimeout(handler);
}, [searchQuery]);
  // ============================================================
  // 🔥 Fetch Top Search Products
  // ============================================================
useEffect(() => {
  const fetchTopSearched = async () => {
    try {
      const res = await api.get(
        "/master-catalogue/api/top-search",
        {
          headers: {
            Accept: "application/json",
          },
        }
      );

      setTopSearchedProducts(res.data || []);
    } catch (error) {
      console.error("Error fetching top searched products:", error);
      setTopSearchedProducts([]);
    }
  };

  fetchTopSearched();
}, []);


  // ============================================================
  // 🔥 Fetch Offers
  // ============================================================

useEffect(() => {
  if (!selectedProduct) {
    setOffersForSelectedProduct([]);
    return;
  }
      const lat = localStorage.getItem("latitude");
      const lng = localStorage.getItem("longitude");
        if (!lat || !lng) {
    console.warn("Latitude or Longitude missing → Skipping API call");
    setOffersForSelectedProduct([]);
    return;
  }

  const fetchOffers = async () => {
    try {
      // const lat = 25.0849855;
      // const lng = 55.1998166;
      const token = localStorage.getItem("accessToken");
      const hyveProductId = selectedProduct.hyveProductId;

      const url = `/store-offer/api/offers/show/product?hyveProductId=${hyveProductId}&lat=${lat}&lng=${lng}`;

      const response = await api.get(url, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      // THE ONLY THING YOU NEED → response.data.offers
      let offers = response.data?.offers || [];

      // optional: filter by selectedArea (same as your old logic)
      // if (selectedArea !== "Near me") {
      //   offers = offers.filter(
      //     (offer) =>
      //       offer.branches?.some((b) => b.branchName === selectedArea)
      //   );
      // }

      setOffersForSelectedProduct(offers);
    } catch (error) {
      console.error("Error fetching offers:", error);
      setOffersForSelectedProduct([]);
    }
  };

  fetchOffers();
}, [selectedProduct, selectedArea ,isLoggedIn]);



  function handleSearchSubmit(e) {
    e.preventDefault();
    if (filteredProducts.length > 0) {
      setSelectedProduct(filteredProducts[0]);
    } else {
      setSelectedProduct(null);
    }
  }

  function handleUseMyLocation() {
    if (!navigator.geolocation) {
      setGeoError("Geolocation is not supported in this browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setGeoError("");
        setUserLocation({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        });
      },
      () => {
        setGeoError("Unable to fetch your current location.");
      }
    );
  }

  return (

    <div className="min-h-screen bg-gradient-to-b from-indigo-50 via-slate-50 to-slate-100 flex flex-col text-slate-900">
      {/* Top nav */}
      <Navbar
        selectedArea={selectedArea}
        setSelectedArea={setSelectedArea}
        isLoggedIn={isLoggedIn}
        setIsLoggedIn={setIsLoggedIn}
        onLoginClick={() => setShowAuthModal(true)}
      />

      {/* Hero */}
      <section className="px-4 mt-3 grid gap-3 md:grid-cols-[minmax(0,2.1fr)_minmax(0,1.2fr)]">
        <div>
          <h1 className="text-xl md:text-2xl font-semibold tracking-tight mb-2">
            Find the best in-store prices in <span className="text-indigo-600">Dubai</span>
          </h1>
          <p className="text-sm text-slate-600 max-w-xl">
            Compare phones, laptops, TVs and home appliances across popular UAE
            retailers. See real in-store prices, distances and catalogs before you go.
          </p>

          <form
            onSubmit={handleSearchSubmit}
            className="mt-3 flex items-center gap-2 bg-white rounded-full shadow-lg border border-slate-200 px-3 py-1.5"
          >
            <Search className="w-4 h-4 text-slate-400" />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="What are you shopping for today?"
              className="flex-1 text-xs md:text-sm bg-transparent border-none focus:outline-none"
            />
            <button
              type="submit"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-indigo-600 text-white text-xs font-medium shadow-md"
            >
              Search
            </button>
          </form>

          {geoError && (
            <p className="mt-1 text-[0.72rem] text-red-500">{geoError}</p>
          )}

          {filteredProducts.length > 0  && (
            <div className="mt-2 flex flex-wrap items-center gap-2 text-[0.75rem] text-slate-500">
              <span>Quick picks:</span>
              {filteredProducts.slice(0, 5).map((p) => (
                <button
                  key={p.productId}
                  type="button"
                  onClick={() => setSelectedProduct(p)}
                  className="px-2 py-0.5 rounded-full border border-slate-300 bg-white text-[0.72rem] hover:border-indigo-500 hover:text-indigo-600"
                >
                  {p.productName}
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="bg-gradient-to-br from-indigo-600 to-blue-600 text-white rounded-2xl shadow-xl p-4 text-xs md:text-[0.85rem] flex flex-col justify-between">
          <div>
            <p className="font-semibold mb-2 flex items-center gap-1.5">
              <Sparkles className="w-4 h-4" />
              Why shoppers love DealFinder
            </p>
            <ul className="space-y-1">
              <li>✔ One glance price comparison across big UAE retailers</li>
              <li>✔ See how far each store is before you leave home</li>
              <li>✔ Lowest price store is locked until you login</li>
              <li>✔ Browse in-store catalogs like a digital booklet</li>
            </ul>
          </div>
          <p className="mt-3 text-[0.7rem] text-indigo-100">
            Designed for busy Dubai shoppers who want to save time and money.
          </p>
        </div>
      </section>

      {/* Main layout */}
      <main className="flex-1 px-4 py-3 grid gap-3 md:grid-cols-[minmax(0,1.7fr)_minmax(0,1.3fr)]">
        <div className="space-y-3">
          {selectedProduct ? (
            <ProductDetailsAndOffers
              SearchedProduct={selectedProduct}
              offers={offersForSelectedProduct}
              isLoggedIn={isLoggedIn}
              selectedArea={selectedArea}
            />
          ) : (
            <EmptyState />
          )}

          <TopSearchedProducts
            products={topSearchedProducts}
            onSelectProduct={setSelectedProduct}
          />
        </div>

        <div className="space-y-3">
          <MapAndStoresPanel
            selectedProduct={selectedProduct}
            offers={offersForSelectedProduct}
            selectedArea={selectedArea}
            userLocation={userLocation}
          />

          <CatalogSection
            catalogs={MOCK_CATALOGS}
            onOpenCatalog={setSelectedCatalog}
          />
        </div>
      </main>

      {/* Catalog booklet modal */}
      {selectedCatalog && (
        <CatalogModal catalog={selectedCatalog} onClose={() => setSelectedCatalog(null)} />
      )}

      {showAuthModal && (
        <AuthModal
          onClose={() => setShowAuthModal(false)}
          setIsLoggedIn={setIsLoggedIn}
        />
      )}

      {/* Footer */}
      <Footer/>
    </div>
  );
}
